import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden" aria-labelledby="cta-heading">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fresh%20green%20vegetables%20and%20herbs%20scattered%20on%20a%20clean%20white%20marble%20surface%20with%20soft%20natural%20morning%20light%2C%20minimalist%20flat%20lay%20food%20photography%2C%20vibrant%20green%20colors%2C%20clean%20and%20fresh%20aesthetic&width=1600&height=600&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-800/85 to-primary-700/75"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-xl mx-auto text-center">
          <h3 id="cta-heading" className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
            新鲜生活，从新有菜开始
          </h3>
          <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-8">
            每日清晨采摘，冷链直配到家。让最新鲜的蔬菜，滋养您和家人的每一天。
          </p>
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 font-semibold rounded-full text-sm hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即选购新鲜蔬菜
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}